import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import AceEditor from "react-ace";

interface Props {
  testName: string;
  logType: string;
  logs: string[];
  onClose: () => void;
}

function TestLogsDialog(props: Props) {
  const { testName, logType, logs, onClose } = props;

  return (
    <Dialog
      open={true}
      scroll="paper"
      onClose={onClose}
      aria-labelledby="test-logs-dialog-title"
      aria-describedby="test-logs-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle disableTypography>
        <Typography variant="h6" color="primary">{testName} Logs ({logType})</Typography>
      </DialogTitle>
      <DialogContent>
        <div>
          <AceEditor
            readOnly
            wrapEnabled
            mode="powershell"
            theme={'monokai'}
            width="100%"
            minLines={20}
            maxLines={Infinity}
            value={logs.join('\n')}
            setOptions={{ useWorker: false, showGutter: false, highlightActiveLine: false }}
            showPrintMargin={false}
            editorProps={{ $blockScrolling: true }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TestLogsDialog;
